import * as XLSX from 'xlsx';

export const readDataFromXlsxFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const binaryData = event.target.result;
        const data = new Uint8Array(binaryData);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const result = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        resolve(result);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (err) => {
      reject(err);
    };

    reader.readAsArrayBuffer(file);
  });
};
